
<app-header *ngIf="isAnonymousUser"></app-header>

<ng-container *ngIf="!loading; else spinner">

  <!-- Show start panel to user from organizator -->
  <app-scotty-card *ngIf="!isTrainingStarted" title="Training session">

    <div class="row">

      <!-- Equipment preview -->
      <img [src]="equipmentImageUrl" alt="equipment-preview" class="equipment-preview">

      <!-- Equipment description -->
      <div class="column">

        <!-- General information -->
        <div class="group-title">General information</div>
        <div class="group">

          <!-- Brand -->
          <mat-form-field>
            <mat-label>Brand</mat-label>
            <input matInput [value]="equipment.manufacturer" readonly>
          </mat-form-field>
          <br>

          <!-- Model -->
          <mat-form-field>
            <mat-label>Model</mat-label>
            <input matInput [value]="equipment.name" readonly>
          </mat-form-field>
          <br>

          <!-- Asset SN -->
          <mat-form-field>
            <mat-label>Asset serial number</mat-label>
            <input matInput [value]="asset.serialNumber" readonly>
          </mat-form-field>
          <br>

          <!-- Description -->
          <mat-form-field class="standard">
            <mat-label>Description</mat-label>
            <textarea matInput [value]="equipment.description" readonly></textarea>
          </mat-form-field>

        </div>

      </div>

      <div class="column">

        <!-- Schedule info -->
        <div class="group-title">Event schedule</div>

        <!-- Calendar icon -->
        <img class="calendar" src="assets/img/calendar.png" alt="calendar">

        <!-- Start date -->
        <mat-form-field>
          <mat-label>Start date</mat-label>
          <input matInput class="time" [value]="event.scheduledAt | date:'medium'" readonly />
        </mat-form-field>

        <!-- End date -->
        <mat-form-field>
          <mat-label>End date</mat-label>
          <input matInput class="time" [value]="event.endAt | date:'medium'" readonly />
        </mat-form-field>

        <!-- Enter videocall -->
        <button mat-raised-button color="primary" class="start-training" (click)="startTraining()" [disabled]="!canStartTraining()">{{startTrainingButtonText}}</button>

      </div>

    </div>

  </app-scotty-card>

  <!-- Videochat training session -->
  <app-assistance-view
    *ngIf="isTrainingStarted"
    [class.isAnonymousUser]="isAnonymousUser"
    [assistance]="fakeMaintenance"
    [assistanceType]="AssistanceType.TRAINING"
    [userName]="userName"
    [userSurname]="userSurname"
    [userId]="userId"
    [useCustomName]="isAnonymousUser"
    [canEditScene]="false"
    [canClose]="canClose && !isAnonymousUser"
    (onClosed)="closeTraining()"
  ></app-assistance-view>

</ng-container>

<ng-template #spinner>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
